import { render, staticRenderFns } from "./DappDetailedNftsContent.vue?vue&type=template&id=34533069&scoped=true"
import script from "./DappDetailedNftsContent.vue?vue&type=script&lang=ts"
export * from "./DappDetailedNftsContent.vue?vue&type=script&lang=ts"
import style0 from "./DappDetailedNftsContent.vue?vue&type=style&index=0&id=34533069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34533069",
  null
  
)

export default component.exports